// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The Refresh button is placed by PageHeaderSlot, inside \`.page-head-actions\`,
   so it no longer needs a float to reach the heading's row — the header row
   itself is the thing that puts it there. */

/* The app UI is always light — force a solid, always-visible button regardless
   of the OS/browser colour-scheme preference. (Previously a
   \`prefers-color-scheme: dark\` block turned the button nearly transparent, so
   on a laptop set to dark mode the Refresh button was invisible on the light
   page.) Values are hard-coded (not theme vars) so no ancestor can wash it out. */
.refresh-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid var(--n-300);
  border-radius: var(--radius-lg);
  background: var(--n-0);
  color: var(--n-800);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  line-height: var(--lh-tight);
  transition: background var(--dur-base) ease, border-color var(--dur-base) ease, box-shadow var(--dur-base) ease;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  appearance: none;
}
.refresh-btn:hover {
  background: var(--n-100);
  border-color: var(--n-400);
}
.refresh-btn:active {
  transform: translateY(1px);
}
.refresh-btn svg {
  flex-shrink: 0;
}

.refresh-btn-spin {
  animation: refresh-btn-rotate var(--dur-slower) linear infinite;
  transform-origin: 50% 50%;
}
@keyframes refresh-btn-rotate {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/RefreshButton.css"],"names":[],"mappings":"AAAA;;4CAE4C;;AAE5C;;;;kFAIkF;AAClF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,+GAA+G;EAC/G,mBAAmB;EACnB,4CAA4C;EAE5C,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,+DAA+D;EAC/D,yBAAyB;AAC3B;AACA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":["/* The Refresh button is placed by PageHeaderSlot, inside `.page-head-actions`,\n   so it no longer needs a float to reach the heading's row — the header row\n   itself is the thing that puts it there. */\n\n/* The app UI is always light — force a solid, always-visible button regardless\n   of the OS/browser colour-scheme preference. (Previously a\n   `prefers-color-scheme: dark` block turned the button nearly transparent, so\n   on a laptop set to dark mode the Refresh button was invisible on the light\n   page.) Values are hard-coded (not theme vars) so no ancestor can wash it out. */\n.refresh-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border: 1px solid var(--n-300);\n  border-radius: var(--radius-lg);\n  background: var(--n-0);\n  color: var(--n-800);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  line-height: var(--lh-tight);\n  transition: background var(--dur-base) ease, border-color var(--dur-base) ease, box-shadow var(--dur-base) ease;\n  white-space: nowrap;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n  -webkit-appearance: none;\n  appearance: none;\n}\n.refresh-btn:hover {\n  background: var(--n-100);\n  border-color: var(--n-400);\n}\n.refresh-btn:active {\n  transform: translateY(1px);\n}\n.refresh-btn svg {\n  flex-shrink: 0;\n}\n\n.refresh-btn-spin {\n  animation: refresh-btn-rotate var(--dur-slower) linear infinite;\n  transform-origin: 50% 50%;\n}\n@keyframes refresh-btn-rotate {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
